import React from 'react'
import classnames from 'classnames'

const NavItem = props => {
  const { children, selected, className, style, onClick } = props
  return (
    <div
      className={classnames('cookunity__nav_item', { selected }, className)}
      style={style}
      onClick={onClick}>
      {children}
    </div>
  )
}

export default NavItem



// WEBPACK FOOTER //
// ./src/components/Nav/NavItem.jsx